module.exports = __webpack_public_path__ + "static/img/3.040c793.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/eng/3.png
// module id = v5ah
// module chunks = 0